export const roleOperationMap = {
  AGENCYOPERATORROLE_AGENCY_ADMIN: {
    create: 102,
    edit: 102,
    detail: 102,
    delete: null,
  }, // 管理员
  AGENCYOPERATORROLE_AGENCY_OBSERVER: {
    create: 104,
    edit: 104,
    detail: 104,
    delete: 104,
  }, // 报表分析员
  AGENCYOPERATORROLE_AGENCY_TREASURER: {
    create: 103,
    edit: 103,
    detail: 103,
    delete: 103,
    freelogin: {
      accountList: 14,
      advertising: 17,
      wechatrpt: 2005,
    },
  }, // 财务人员
  AGENCYOPERATORROLE_MDM_OPERATOR: {
    create: 105,
    edit: 105,
    detail: '',
    delete: 105,
  }, // 运营管理员
  AGENCYOPERATORROLE_AGENT_OPERATOR: {
    create: 106,
    edit: 106,
    detail: '',
    delete: 106,
  }, // 运营人员
  OPERATORROLE_TYPE_ADVERTISER: {
    create: null,
    edit: null,
    detail: null,
    delete: null,
  }, // 自理投放管理员
  AGENCYOPERATORROLE_AGENCY_BOSS: {
    create: null,
    edit: 112,
    detail: null,
    delete: 112,
  }, // 超级管理员
  AGENCYOPERATORROLE_MDM_TREASURER: {
    create: 103,
    edit: 103,
    detail: 103,
    delete: 103,
    freelogin: {
      accountList: 14,
      accountDetails: 11,
      accountEdit: 12,
      advertising: 17,
      wechatrpt: 2005,
      // 编辑联系人
      linkPersonEdit: 9128793,
    },
  }, // 广告主列表页面用的配置
};

export const wxRoleOperationMap = {
  ROLE_TYPE_ADMINISTRATOR: {
    create: 102,
    edit: 102,
    detail: '',
    delete: 102,
  }, // 管理员
  ROLE_TYPE_FINANCIAL_OFFICER: {
    create: 103,
    edit: 103,
    detail: '',
    delete: 103,
  }, // 财务人员
  ROLE_TYPE_OPERATION_SUPERVISOR: {
    create: 105,
    edit: 105,
    detail: '',
    delete: 105,
  }, // 运营管理员
  ROLE_TYPE_OPERATOR: {
    create: 106,
    edit: 106,
    detail: '',
    delete: 106,
  }, // 运营人员
  ROLE_TYPE_SUPER_ADMINISTRATOR: {
    create: null,
    edit: 112,
    detail: null,
    delete: null,
  }, // 超级管理员
};

export const operationButtonPermissionMap = {
  AGENCYOPERATORROLE_AGENCY_BOSS: {
    AGENCYOPERATORROLE_AGENCY_ADMIN: {
      create: null,
      edit: 102,
      detail: null,
      delete: 102,
    }, // 管理员
    AGENCYOPERATORROLE_AGENCY_OBSERVER: {
      create: null,
      edit: 104,
      detail: null,
      delete: 104,
    }, // 报表分析员
    AGENCYOPERATORROLE_AGENCY_TREASURER: {
      create: null,
      edit: 103,
      detail: null,
      delete: 103,
    }, // 财务人员 超级管理员可编辑删除财务人员
    AGENCYOPERATORROLE_MDM_OPERATOR: {
      create: 105,
      edit: 105,
      detail: '',
      delete: 105,
    }, // 运营管理员
    AGENCYOPERATORROLE_AGENT_OPERATOR: {
      create: 106,
      edit: 106,
      detail: '',
      delete: 106,
    }, // 运营人员
    AGENCYOPERATORROLE_AGENCY_BOSS: {
      create: null,
      edit: 112,
      detail: null,
      delete: null,
    }, // 超级管理员
  },
  AGENCYOPERATORROLE_AGENCY_ADMIN: {
    AGENCYOPERATORROLE_AGENCY_BOSS: {
      create: null,
      edit: null,
      detail: null,
      delete: null,
    }, // 管理员不可编辑删除新建超级管理员
    AGENCYOPERATORROLE_AGENCY_ADMIN: {
      create: null,
      edit: null,
      detail: null,
      delete: null,
    }, // 管理员不可编辑新建管理员
    AGENCYOPERATORROLE_AGENCY_TREASURER: {
      create: null,
      edit: null,
      detail: null,
      delete: null,
    }, // 管理员不可编辑删除财务人员
    AGENCYOPERATORROLE_AGENCY_OBSERVER: {
      create: 104,
      edit: 104,
      detail: '',
      delete: 104,
    }, // 报表分析员
    AGENCYOPERATORROLE_MDM_OPERATOR: {
      create: 105,
      edit: 105,
      detail: '',
      delete: 105,
    }, // 运营管理员
    AGENCYOPERATORROLE_AGENT_OPERATOR: {
      create: 106,
      edit: 106,
      detail: '',
      delete: 106,
    }, // 运营人员
  },
};

export const reportPagesOperationMap = {
  download: '',
  create: '',
  delete: '',
  edit: '',
};

export const roleActionUrlMap = {
  AGENCYOPERATORROLE_MDM_BOSS: { createAction: '', updateAction: '' }, // 超级主体管理员
  AGENCYOPERATORROLE_MDM_ADMIN: {
    createAction: 'create_basic_operator',
    updateAction: 'update_basic_operator',
  }, // 主体管理员
  AGENCYOPERATORROLE_MDM_TREASURER: {
    createAction: 'create_basic_operator',
    updateAction: 'update_basic_operator',
  }, // 主体财务人员
  AGENCYOPERATORROLE_AGENCY_ADMIN: {
    createAction: 'create_basic_operator',
    updateAction: 'update_basic_operator',
  }, // 管理员
  AGENCYOPERATORROLE_AGENCY_OBSERVER: {
    createAction: 'create_basic_operator',
    updateAction: 'update_basic_operator',
  }, // 报表分析员
  AGENCYOPERATORROLE_AGENCY_TREASURER: {
    createAction: 'create_basic_operator',
    updateAction: 'update_basic_operator',
  }, // 财务人员
  AGENCYOPERATORROLE_MDM_OPERATOR: {
    createAction: 'create_manager_operator',
    updateAction: 'update_manager_operator',
  }, // 运营管理员
  AGENCYOPERATORROLE_AGENT_OPERATOR: {
    createAction: 'create_staff_operator',
    updateAction: 'update_staff_operator',
  }, // 运营人员
  OPERATORROLE_TYPE_ADVERTISER: {
    create: null,
    edit: null,
    detail: null,
    delete: null,
  }, // 自理投放管理员
  AGENCYOPERATORROLE_AGENCY_BOSS: {
    create: null,
    edit: 112,
    detail: null,
    delete: null,
  }, // 超级管理员
};

export const noOperationColumnRole = ['AGENCYOPERATORROLE_MDM_BOSS', 'AGENCYOPERATORROLE_AGENCY_ADMIN', 'AGENCYOPERATORROLE_AGENCY_BOSS', 'AGENCYOPERATORROLE_AGENCY_OBSERVER', 'AGENCYOPERATORROLE_AGENCY_TREASURER', 'AGENCYOPERATORROLE_AGENCY_OPERATOR', 'OPERATORROLE_TYPE_ADVERTISER'];

export const allTabRoleList = [
  {
    value: 'AGENCYOPERATORROLE_AGENCY_BOSS',
    value1: 100,
    label: '超级管理员',
    tip: '超级管理员：可进行单帐号维度员工管理及角色权限分配、及其他所有操作；',
  }, // 老系统BOSS管理员
  {
    value: 'AGENCYOPERATORROLE_AGENCY_ADMIN',
    value1: 101,
    label: '管理员',
    tip: '管理员：由超级管理员任命，可进行单帐号维度员工管理及角色权限分配、及其他所有操作；',
  },
  {
    value: 'AGENCYOPERATORROLE_MDM_OPERATOR',
    value1: 114,
    label: '运营管理员',
    tip: '运营管理员：只能操作及查看其管理的员工对应的广告主数据；',
  },
  {
    value: 'AGENCYOPERATORROLE_AGENT_OPERATOR',
    value1: 108,
    label: '运营人员',
    tip: '运营人员：可对其绑定的广告主进行广告投放、数据查看；',
  },
  {
    value: 'AGENCYOPERATORROLE_AGENCY_TREASURER',
    value1: 103,
    label: '财务人员',
    tip: '财务人员：可进行单帐号维度财务信息管理；',
  }, // 财务人员是财务分析员
  {
    value: 'AGENCYOPERATORROLE_AGENCY_OBSERVER',
    value1: 102,
    label: '报表分析员',
    tip: '报表分析员：可进行单帐号维度报表数据查看；',
  },
];

// {AGENCYOPERATORROLE_AGENCY_BOSS: 100}
export const allRoleListMap = allTabRoleList.reduce((prev, curr) => {
  return {
    ...prev,
    [curr.value]: curr.value1,
  };
}, {});

export const ROLES_NAME_TO_ID = {
  CUSTOMER_ROLE_MAGIC_GENERAL: 99, // 免登录
  OPERATORROLE_ADMIN: 1, // 管理员，所有权限
  OPERATORROLE_AGENT_OPERATOR: 8, // 广告主代理协作者类型（由服务商协作者投放管理类型拆分而来）
  AGENCYOPERATORROLE_AGENCY_BOSS: 100,
  AGENCYOPERATORROLE_AGENCY_ADMIN: 101,
  AGENCYOPERATORROLE_AGENCY_OPERATOR: 108,
  AGENCYOPERATORROLE_MDM_BOSS: 110, // 代理商主体超级管理员
  AGENCYOPERATORROLE_MDM_ADMIN: 111, // 代理商主体管理员
  AGENCYOPERATORROLE_AGENCY_MDM_OPERATOR: 114,
  AGENCYOPERATORROLE_AGENCY_OBSERVER_OPERATOR: 118,
  AGENCYOPERATORROLE_AGENCY_SUB_ADMIN: 117, // 子账号管理员
  AGENCYOPERATORROLE_AGENCY_DESIGNER: 116, // 设计师
};

export function isAdmin(role_list = {}) {
  return Boolean(role_list[ROLES_NAME_TO_ID.AGENCYOPERATORROLE_AGENCY_ADMIN]);
}

export function isBoss(role_list = {}) {
  return Boolean(role_list[ROLES_NAME_TO_ID.AGENCYOPERATORROLE_AGENCY_BOSS]);
}

export function isBossOrAdmin(role_list = {}) {
  return Boolean(role_list[ROLES_NAME_TO_ID.AGENCYOPERATORROLE_AGENCY_BOSS] || role_list[ROLES_NAME_TO_ID.AGENCYOPERATORROLE_AGENCY_ADMIN]);
}

// 当前用户角色是否在目标角色列表中
export function inRoleList(role_list = {}, checkTargetRoles = []) {
  for (const role of checkTargetRoles) {
    if (Boolean(role_list[role])) {
      return true;
    }
  }
  return false;
}

export const allWxTabRoleList = [
  {
    value: 'ROLE_TYPE_SUPER_ADMINISTRATOR',
    value1: 100,
    label: '超级管理员',
    tip: '超级管理员：可进行单帐号维度员工管理及角色权限分配、及其他所有操作；',
  }, // 老系统BOSS管理员
  {
    value: 'ROLE_TYPE_ADMINISTRATOR',
    value1: 101,
    label: '管理员',
    tip: '管理员：由超级管理员任命，可进行单帐号维度员工管理及角色权限分配、及其他所有操作；',
  },
  {
    value: 'ROLE_TYPE_OPERATION_SUPERVISOR',
    value1: 114,
    label: '运营管理员',
    tip: '运营管理员：只能操作及查看其管理的员工对应的广告主数据；',
  },
  {
    value: 'ROLE_TYPE_OPERATOR',
    value1: 108,
    label: '运营人员',
    tip: '运营人员：可对其绑定的广告主进行广告投放、数据查看；',
  },
  {
    value: 'ROLE_TYPE_FINANCIAL_OFFICER',
    value1: 103,
    label: '财务人员',
    tip: '财务人员：可进行单帐号维度财务信息管理；',
  },
  // {value:'AGENCYOPERATORROLE_AGENCY_OBSERVER',value1: '102', label: '报表分析人员', tip: '报表分析人员：可进行单帐号维度报表数据查看；'}
];
export const gdtManagerRoleSelect = [
  {
    value: 'AGENCYOPERATORROLE_MDM_OPERATOR',
    value1: 114,
    label: '运营管理员',
    tip: '运营管理员：只能操作及查看其管理的员工对应的广告主数据；',
  },
  {
    value: 'AGENCYOPERATORROLE_AGENT_OPERATOR',
    value1: 108,
    label: '运营人员',
    tip: '运营人员：可对其绑定的广告主进行广告投放、数据查看；',
  },
  {
    value: 'AGENCYOPERATORROLE_AGENCY_TREASURER',
    value1: 103,
    label: '财务人员',
    tip: '财务人员：可进行单帐号维度财务信息管理；',
  }, // 财务人员是财务分析员
  {
    value: 'AGENCYOPERATORROLE_AGENCY_OBSERVER',
    value1: 102,
    label: '报表分析员',
    tip: '报表分析员：可进行单帐号维度报表数据查看；',
  },
];
export const wxManagerRoleSelect = [
  {
    value: 'ROLE_TYPE_OPERATION_SUPERVISOR',
    value1: 114,
    label: '运营管理员',
    tip: '运营管理员：只能操作及查看其管理的员工对应的广告主数据；',
  },
  {
    value: 'ROLE_TYPE_OPERATOR',
    value1: 108,
    label: '运营人员',
    tip: '运营人员：可对其绑定的广告主进行广告投放、数据查看；',
  },
  {
    value: 'ROLE_TYPE_FINANCIAL_OFFICER',
    value1: 103,
    label: '财务人员',
    tip: '财务人员：可进行单帐号维度财务信息管理；',
  },
  // {value:'AGENCYOPERATORROLE_AGENCY_OBSERVER',value1: '102', label: '报表分析人员', tip: '报表分析人员：可进行单帐号维度报表数据查看；'}
];
// 根据当前登录人的角色进行设置
export const superTabList = allTabRoleList.slice(0, 6);
export const themeTabList = allTabRoleList.slice(0, 6);
// 新建员工时，角色不可以为超级管理员
export const gdtRoleSelect = allTabRoleList.slice(1, 6);
export const wxRoleSelect = allTabRoleList.slice(1, 5);
export const gdtBossRoleSelect = allTabRoleList.slice(0, 1);
export const wxBossRoleSelect = allWxTabRoleList.slice(0, 1);

// 主体管理员/主体财务人员/主体报表分析员 //运营管理员 运营人员
export const operator = 'AGENCYOPERATORROLE_MDM_OPERATOR'; // 运营管理员
export const proxyDeliveryManager = 'AGENCYOPERATORROLE_AGENT_OPERATOR'; // 运营人员

export const themeManager = 'AGENCYOPERATORROLE_MDM_ADMIN';
export const themeFinanceManager = 'AGENCYOPERATORROLE_MDM_TREASURER';

// 超级管理员可分配除管理员/财务人员/运营管理员/运营人员
export const superThemeManagerSelect = allTabRoleList.slice(1, 5);
// 主体管理员可分配主体财务人员/主体报表分析员 //运营管理员 运营人员
export const themeManagerSelect = allTabRoleList.slice(2, 5);

export const roleLevelList = [
  {
    value: 1,
    label: '初级',
  },
  {
    value: 2,
    label: '中级',
  },
  {
    value: 3,
    label: '未认证',
  },
];
export const createDialog = function (title, msg) {
  return {
    show: true,
    title,
    children: msg,
    cancelButton: true,
    type: 'normal',
    style: { width: '450px' },
  };
};
export const manageBoss = 'AGENCYOPERATORROLE_AGENCY_BOSS';
export const manageRole = 'AGENCYOPERATORROLE_AGENCY_ADMIN';
export const allProxyOperator = 'AGENCYOPERATORROLE_AGENCY_OPERATOR';
export const reportAnalyst = 'AGENCYOPERATORROLE_AGENCY_OBSERVER';
export const hasPickerRole = [operator, proxyDeliveryManager];
export const wxAgency = 'wx';
export const gdtAgency = 'gdt';
export const GDT_TYPE = 1;
export const WX_TYPE = 2;
export const wxOperator = 'ROLE_TYPE_OPERATION_SUPERVISOR';
export const wxProxyDeliveryManager = 'ROLE_TYPE_OPERATOR';
export const GDT_WECHAT_ROLE_MAP = {
  AGENCYOPERATORROLE_AGENCY_ADMIN: 'ROLE_TYPE_ADMINISTRATOR',
  AGENCYOPERATORROLE_AGENCY_BOSS: 'ROLE_TYPE_SUPER_ADMINISTRATOR',
  AGENCYOPERATORROLE_AGENCY_TREASURER: 'ROLE_TYPE_FINANCIAL_OFFICER',
  AGENCYOPERATORROLE_MDM_OPERATOR: 'ROLE_TYPE_OPERATION_SUPERVISOR',
  AGENCYOPERATORROLE_AGENT_OPERATOR: 'ROLE_TYPE_OPERATOR',
};
export const AGENCYOPERATORROLE_AGENCY_TREASURER = '103'; // 财管
export const AGENCYOPERATORROLE_AGENCY_BOSS = '100'; // 超管
/*
*
*

主体管理员删除1
主体财务人员删除2
管理员 查看3
报表分析员 查看4
财务人员 查看5
运营管理员 编辑6 删除7
运营人员 编辑8 删除9
自理投放管理员 查看10
* */
export default {
  operationButtonPermissionMap,
  gdtManagerRoleSelect,
  wxManagerRoleSelect,
  reportAnalyst,
  GDT_WECHAT_ROLE_MAP,
  createDialog,
  wxOperator,
  wxProxyDeliveryManager,
  GDT_TYPE,
  WX_TYPE,
  gdtRoleSelect,
  wxRoleSelect,
  roleActionUrlMap,
  allTabRoleList,
  allWxTabRoleList,
  superThemeManagerSelect,
  themeManagerSelect,
  roleLevelList,
  themeManager,
  themeFinanceManager,
  operator,
  proxyDeliveryManager,
  manageBoss,
  manageRole,
  wxAgency,
  gdtAgency,
  superTabList,
  themeTabList,
  roleOperationMap,
  wxRoleOperationMap,
  noOperationColumnRole,
  allProxyOperator,
  hasPickerRole,
  reportPagesOperationMap,
  gdtBossRoleSelect,
  wxBossRoleSelect,
  AGENCYOPERATORROLE_AGENCY_TREASURER,
  AGENCYOPERATORROLE_AGENCY_BOSS,
};
